"use client";

import { c as _c } from "react/compiler-runtime";
import { FC, useMemo } from "react";
import LinkButton from "../ui/Link";
import { SubPages } from '@/types/home';
type NavItem = {
  label: string;
  href: string;
};
interface Props {
  data?: SubPages[];
}
const Nav = t0 => {
  const $ = _c(5);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "\u0641\u06CC\u0644\u0645",
      href: "/movies"
    }, {
      label: "\u0633\u0631\u06CC\u0627\u0644",
      href: "/series"
    }, {
      label: "\u06A9\u0648\u062F\u06A9 \u0648 \u0646\u0648\u062C\u0648\u0627\u0646",
      href: "/kids"
    }, {
      label: "\u06A9\u0633\u0628 \u0648 \u06A9\u0627\u0631",
      href: "/business"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const navItems = t1;
  let t2;
  if ($[1] !== data) {
    t2 = data ? data.map(_temp) : navItems.map(_temp2);
    $[1] = data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <nav><ul className="flex gap-6">{t2}</ul></nav>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Nav;
function _temp(item) {
  return <li className="flex items-center" key={item.slug}><LinkButton href={"/" + item.slug} className="text-foreground ont-medium" variant="default" size="none">{item.title}</LinkButton></li>;
}
function _temp2(item_0) {
  return item_0.href === "/business" ? <li className="flex items-center" key={item_0.href}><LinkButton href={item_0.href} className="business-btn" variant="default" size="none"><span>{item_0.label}</span></LinkButton></li> : <li className="flex items-center" key={item_0.href}><LinkButton href={item_0.href} className="text-foreground ont-medium" variant="default" size="none">{item_0.label}</LinkButton></li>;
}